import { toastr } from "react-redux-toastr";
import { client_v2 } from "utils/api";

export const getPackageBoxes = () => async (dispatch) => {
  try {
    dispatch({
      type: "PACKAGE_BOXES_LOADING",
    });

    const { data: gdn_package_boxes_stats } = await client_v2.get(
      "/package_boxes/stats",
    );

    const { data: grn_package_stats } = await client_v2.get(
      "/stats/grn_packages_stats",
    );

    const data = { ...gdn_package_boxes_stats };

    Object.keys(grn_package_stats).forEach((range_key) => {
      Object.keys(grn_package_stats[range_key]).forEach((size_key) => {
        const size_quantity = grn_package_stats[range_key][size_key];
        if (data?.[range_key]?.[size_key]) {
          data[range_key][size_key] += size_quantity;
        } else {
          data[range_key][size_key] = size_quantity;
        }
      });
    });

    dispatch({
      type: "PACKAGE_BOXES_SUCCESS",
      data,
    });
  } catch (error) {
    dispatch({ type: "PACKAGE_BOXES_FAILURE" });
    toastr.error("Błąd", "Wystąpił błąd podczas pobierania danych o paczkach");
    throw error;
  }
};
